export function getUrlButtons(components: unknown): { url: string; index: number }[] {
  const buttons: { url: string; index: number }[] = [];
  if (!Array.isArray(components)) return buttons;
  for (const component of components) {
    if (component?.type !== 'BUTTONS' || !Array.isArray(component.buttons)) continue;
    for (const [index, button] of component.buttons.entries()) {
      if (button?.type === 'URL' && typeof button.url === 'string') buttons.push({ url: button.url, index });
    }
  }
  return buttons;
}

export function checkUrlButton(args: {
  expected: 'root' | 'dynamic' | undefined;
  buttons: { url: string; index: number }[];
  expectedBaseUrl: string;
}): string | undefined {
  const { expected, buttons, expectedBaseUrl } = args;
  const expectedUrl = expectedBaseUrl + '{{1}}';
  const firstButton = buttons[0];
  const dynamic = buttons.find(button => button.url.includes('{{1}}'));
  if (expected) {
    if (!firstButton) {
      return `URL-Button fehlt — erwartet wird ein dynamischer Button${
        expected === 'root' ? ` mit ${expectedUrl}` : ''
      }`;
    }
    if (!dynamic) {
      return `URL-Button ist statisch (${firstButton.url}) — erwartet wird ${
        expected === 'root' ? expectedUrl : 'ein dynamischer Button'
      }`;
    }
    if (expected === 'root' && dynamic.url !== expectedUrl) {
      return `URL-Button zeigt auf ${dynamic.url} — erwartet wird ${expectedUrl}`;
    }
    if (dynamic.index !== 0) {
      return `URL-Button steht an Position ${
        dynamic.index + 1
      } — er muss der erste Button sein (Index 0), sonst lehnt Meta den Versand ab`;
    }
  } else if (dynamic) {
    return `Template hat einen dynamischen URL-Button (${dynamic.url}), der Versand übergibt aber keinen Button-Parameter`;
  }
  return undefined;
}
